module.exports = __webpack_public_path__ + "img/apple.be5030ca.webp";